import React from 'react';
import { Typography, Box, Fade, Chip, Stack } from '@mui/material';

const ResearchInterests = ({ skills }) => (
  <Fade in timeout={1000}>
    <Box id="skills" sx={{ py: { xs: 3, md: 5 }, px: { xs: 1, md: 0 }, maxWidth: { xs: '100%', md: 1200 }, mx: 'auto' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        <Box sx={{ width: 4, height: 32, bgcolor: 'primary.main', mr: 2, borderRadius: 2 }} />
        <Typography variant="h4" fontWeight={700} sx={{ fontFamily: 'Montserrat, sans-serif', letterSpacing: 1, fontSize: { xs: 24, md: 32 } }}>
          Research Interests
        </Typography>
      </Box>
      <Stack direction="row" flexWrap="wrap" gap={2} mt={2}>
        {skills.map(skill => (
          <Chip 
            key={skill} 
            label={skill} 
            color="primary" 
            variant="outlined" 
            sx={{ 
              fontSize: { xs: 14, md: 16 }, 
              fontWeight: 500, 
              fontFamily: 'Montserrat, sans-serif',
              height: { xs: 32, md: 36 },
              '&:hover': {
                bgcolor: 'primary.main',
                color: 'white',
                transition: 'all 0.2s ease-in-out'
              }
            }} 
          />
        ))}
      </Stack>
    </Box>
  </Fade>
);

export default ResearchInterests; 